import { render } from "./OffsetContainer.vue?vue&type=template&id=15815b96&scoped=true"
import script from "./OffsetContainer.vue?vue&type=script&lang=js"
export * from "./OffsetContainer.vue?vue&type=script&lang=js"

import "./OffsetContainer.vue?vue&type=style&index=0&id=15815b96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15815b96"]])

export default __exports__